<app-modal
  #unsavedChanges
  [modalMessage]="app.text.app.confirmChanges"
  [showButtons]="false"
></app-modal>

<app-session-expires-modal
  #sessionExpires
  data-backdrop="static"
  data-keyboard="false"
>
</app-session-expires-modal>

<div [ngClass]="{ 'app-container': !app.pcnGenerator.isPcnGenerator }">
  <div class="app-content">
    <div
      *ngIf="app.error && !app.hasError"
      class="error-notification top-bar"
      style="cursor: pointer"
    >
      <div class="container">
        <div class="p-1">
          <div class="col-md-2 pull-left">
            <i class="fa-solid fa-ban banIcon"></i>
          </div>
          <div class="col-md-10 pull-right">
            <div class="col-md-12 text-danger text-uppercase">
              {{ app.text.app.error }}
              <div class="close-btn pull-right" (click)="app.hasError = false">
                <i class="fa fa-times"></i>
              </div>
            </div>
            <div class="col-md-12">
              {{ app.text.app.errorOccured }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="error-notification top-bar"
      style="cursor: pointer"
      *ngIf="app.hasError"
    >
      <div class="container">
        <div class="p-1">
          <div class="col-md-2 pull-left">
            <i class="fa-solid fa-ban banIcon"></i>
          </div>
          <div class="col-md-10 pull-right">
            <div class="col-md-12 text-danger text-uppercase">
              {{ app.text.app.error }}
              <div class="close-btn pull-right" (click)="app.hasError = false">
                <i class="fa fa-times"></i>
              </div>
            </div>
            <div class="col-md-12">
              {{ app.errorText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SUCCESS -->
    <div
      class="success success-notification top-bar"
      *ngIf="app.hasSuccess"
      style="cursor: pointer"
    >
      <div class="container">
        <div class="p-1">
          <div class="col-md-2 pull-left">
            <i class="fa-solid fa-octagon-check successIcon"></i>
          </div>
          <div class="col-md-10 pull-right">
            <div class="col-md-12 text-success text-uppercase">
              {{ app.text.app.success }}
              <div
                class="close-btn pull-right"
                (click)="app.hasSuccess = false"
              >
                <i class="fa fa-times"></i>
              </div>
            </div>
            <div class="col-md-12">
              {{ app.successText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING -->
    <!-- <div *ngIf="app.busy" class="top-bar">
      <div class="container">
        <div class="p-1">
          <i class="fas fa-sync-alt spin spinner"></i>
          {{ app.text.app.loading }}
        </div>
      </div>
    </div> -->

    <div class="wrapper" *ngIf="!app.busy">
      <!-- Sidebar -->
      <div *ngIf="!app.pcnGenerator.isPcnGenerator" id="sidebar">
        <app-sidebar></app-sidebar>
      </div>

      <!-- Page Contetnt -->
      <div
        id="content"
        [ngClass]="{ whiteBKGD: app.pcnGenerator.isPcnGenerator }"
      >
        <!-- Header -->
        <app-header *ngIf="app.user != null"></app-header>
        <!-- Content -->
        <div class="container-fluid" [ngClass]="app.header.removePadding()">
          <router-outlet></router-outlet>
        </div>
      </div>

      <!-- Panel right -->
      <app-task-panel></app-task-panel>

      <!-- Backdrop for the grayed-out panel effect -->
      <div
        class="backdropPanel"
        [class.active]="app.taskPanel.isOpen"
        (click)="app.taskPanel.closePanel()"
      ></div>

      <!-- Filters -->
      <div id="filters">
        <!-- Filters OM -->
        <div *ngIf="app.filterList.open" id="collapseFilter" class="filter">
          <app-filter [types]="types"></app-filter>
        </div>
        <!-- Filters RM -->
        <div *ngIf="app.RM.filterOpen" id="collapseFilter" class="filter">
          <app-filter-tree></app-filter-tree>
        </div>
        <!-- Filters Dashboard -->
        <div
          *ngIf="app.filterDashboard.isOpen"
          id="collapseFilter"
          class="filter"
        >
          <app-filter-dashboard></app-filter-dashboard>
        </div>
      </div>
      <!-- Side view of creation of the user  -->
      <div
        id="userCreation"
        class="userCreation"
        *ngIf="app.users.creationOpen"
      >
        <div id="collapseCreation">
          <app-user></app-user>
        </div>
      </div>

      <div id="profileView" class="profile" *ngIf="app.profile.viewProfile">
        <div id="collapseProfileView">
          <app-profile></app-profile>
        </div>
      </div>

      <div
        id="entraIdBenefitsView"
        class="entraBenefits"
        *ngIf="app.auth.entraBenefitsOpen"
      >
        <div id="collapseEntraBenefits">
          <div class="row p-3 mt-4">
            <div class="col-md-12">
              <h4>Microsoft Entra ID</h4>
              <p>
                {{ app.getText("user.entraSubtext") }}
              </p>
              <ul class="unlinked">
                <li>
                  <i class="fa-solid fa-right-to-bracket colorize"></i>
                  <div class="li-content">
                    <div class="li-title">
                      {{ app.getText("user.entraSection1Title") }}
                    </div>
                    <div class="li-text">
                      {{ app.getText("user.entraSection1Text") }}
                    </div>
                  </div>
                </li>
                <li>
                  <i class="fa-solid fa-user-lock colorize"></i>
                  <div class="li-content">
                    <div class="li-title">
                      {{ app.getText("user.entraSection2Title") }}
                    </div>
                    <div class="li-text">
                      {{ app.getText("user.entraSection2Text") }}
                    </div>
                  </div>
                </li>
                <li>
                  <i class="fa-solid fa-shield-halved colorize"></i>
                  <div class="li-content">
                    <div class="li-title">
                      {{ app.getText("user.entraSection3Title") }}
                    </div>
                    <div class="li-text">
                      {{ app.getText("user.entraSection3Text") }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Release Notes Banner -->
      <app-release-notes-banner> </app-release-notes-banner>
    </div>
  </div>
</div>

<div class="app-footer">
  <app-footer></app-footer>
</div>

<ngx-spinner size="medium" type="ball-atom" [fullScreen]="true">
  <p class="spinner-text">Loading ...</p>
</ngx-spinner>
